import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, formatApiError } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Truck, WarningCircle } from '@phosphor-icons/react';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const userData = await login(email, password);
      if (userData.role === 'technician') {
        navigate('/technician');
      } else {
        navigate('/');
      }
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="w-full max-w-md">
        <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-xl">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-reco-500/10 mb-4">
              <Truck size={32} weight="fill" className="text-reco-500" />
            </div>
            <h1 className="text-3xl font-heading font-bold text-gray-900">
              <span className="text-reco-500">reco</span>pneus
            </h1>
            <p className="text-gray-500 mt-2">Reco Work - Gestion des interventions</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="flex items-center gap-2 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm" data-testid="login-error">
                <WarningCircle size={18} />
                <span>{error}</span>
              </div>
            )}

            <div className="space-y-2">
              <Label htmlFor="email" className="text-gray-700">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@recowork.fr"
                className="bg-white border-gray-300 text-gray-900 placeholder:text-gray-400 focus:border-reco-500 focus:ring-reco-500"
                required
                data-testid="login-email-input"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="text-gray-700">Mot de passe</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="bg-white border-gray-300 text-gray-900 placeholder:text-gray-400 focus:border-reco-500 focus:ring-reco-500"
                required
                data-testid="login-password-input"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full h-12 bg-reco-500 hover:bg-reco-600 text-white font-semibold text-lg rounded-full"
              data-testid="login-submit-button"
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </Button>
          </form>

          <p className="text-center text-sm text-gray-400 mt-6">
            Intervention 7j/7 - Alpes-Maritimes & Var
          </p>
        </div>
      </div>
    </div>
  );
}
